import { isNumber } from "lodash";

function getCounterFormat(
  value: string | number,
  cols: number,
  direction: "left" | "right",
): { value: number; isActive: boolean }[] {
  try {
    const maxValue = Number(new Array(cols).fill(9).join(""));
    if (maxValue <= Number(value)) {
      return new Array(cols).fill(9).map((item) => ({ value: item, isActive: true }));
    }

    let valueArray: string[] = [];
    if (isNumber(value)) {
      valueArray = String(value).split("");
    } else {
      valueArray = String(Number(value)).split("");
    }

    const counterValue: { value: number; isActive: boolean }[] = new Array(cols).fill({
      value: 0,
      isActive: false,
    });
    if (direction === "left") {
      for (let i = counterValue.length - 1; i >= 0; i -= 1) {
        const digit = valueArray.pop();
        if (digit) {
          counterValue[i] = { value: Number(digit), isActive: true };
        }
      }
    } else {
      for (let i = 0; i < counterValue.length; i += 1) {
        const digit = valueArray.shift();

        if (digit) {
          counterValue[i] = { value: Number(digit), isActive: true };
        }
      }
    }

    return counterValue;
  } catch (e) {
    return new Array(cols).fill(0).map((item) => ({ value: item, isActive: false }));
  }
}

export default getCounterFormat;
